import { useState } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import {
  Center,
  Card,
  Title,
  Text,
  TextInput,
  PasswordInput,
  Button,
  Stack,
  Anchor,
  Divider,
  Alert,
} from "@mantine/core";
import { IconAlertCircle } from "@tabler/icons-react";
import { useAuth } from "../contexts/AuthContext";

export function LoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const { signIn } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const from = (location.state as { from?: { pathname: string } })?.from
    ?.pathname ?? "/";

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    setLoading(true);

    const { error } = await signIn(email, password);
    setLoading(false);

    if (error) {
      setError(error.message);
    } else {
      navigate(from, { replace: true });
    }
  }

  return (
    <Center h="100vh" bg="var(--mantine-color-body)">
      <Card withBorder shadow="sm" padding="xl" radius="md" w={400}>
        <Title order={2} ta="center" mb="xs">
          Showrunner
        </Title>
        <Text c="dimmed" size="sm" ta="center" mb="lg">
          Sign in to manage your prompts
        </Text>

        <form onSubmit={handleSubmit}>
          <Stack>
            {error && (
              <Alert
                icon={<IconAlertCircle size={16} />}
                color="red"
                variant="light"
              >
                {error}
              </Alert>
            )}
            <TextInput
              label="Email"
              placeholder="you@example.com"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.currentTarget.value)}
            />
            <PasswordInput
              label="Password"
              placeholder="Your password"
              required
              value={password}
              onChange={(e) => setPassword(e.currentTarget.value)}
            />
            <Button fullWidth mt="sm" type="submit" loading={loading}>
              Sign in
            </Button>
            <Divider label="or" labelPosition="center" />
            <Text size="sm" ta="center">
              Don't have an account?{" "}
              <Anchor component={Link} to="/signup" size="sm">
                Sign up
              </Anchor>
            </Text>
          </Stack>
        </form>
      </Card>
    </Center>
  );
}
